<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Heartfelt thanks to my wife Guenievre, for her endless encouragement, her boundless enthusiasm, and without whom Freya would not exist.</p><br/>
<p style="text-indent:0em">I would not be where I am, without you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2957bd85